// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popover{min-width:90px}.popoverRow{text-align:center;cursor:pointer;margin-bottom:10px}.popoverRow :hover{color:#0248a7}", ""]);
// Exports
module.exports = exports;
